<div *ngFor="let message of messages" class="custom-snack-bar d-flex flex-column align-items-center border"
    [ngClass]="{ 'border-success': type === 'info', 'bg-success-subtle': type === 'info', 'border-danger': type === 'error', 'bg-danger-subtle': type === 'error' }">

    <div class="custom-snack-bar d-flex flex-row align-items-center gap-3">
        <mat-icon *ngIf="type === 'error'">error</mat-icon>
        <span class="message-container" style="margin-right:20px;">{{ message }}</span>
        <button mat-icon-button (click)="removeMessage(message)" color="accent">
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>